/**
 * HR Hub Utilities
 * Re-exports shared functions from @quotech/ui — HR-specific helpers below.
 */
export {
  cn,
  formatCurrency,
  formatDate,
  formatNumber,
  formatHours,
  getInitials,
  capitalize,
  debounce,
} from '@quotech/ui'

/**
 * Format date relative to now (forward-looking: "In 3 days", "Tomorrow").
 */
export function formatRelativeDate(dateString: string): string {
  const date = new Date(dateString)
  const now = new Date()
  const diffMs = date.getTime() - now.getTime()
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24))

  if (diffDays === 0) return 'Today'
  if (diffDays === 1) return 'Tomorrow'
  if (diffDays === -1) return 'Yesterday'
  if (diffDays > 0 && diffDays <= 7) return `In ${diffDays} days`
  if (diffDays < 0 && diffDays >= -7) return `${Math.abs(diffDays)} days ago`

  return formatDate(dateString)
}

/**
 * Format status for display (replace underscores with spaces, title case).
 */
export function formatStatus(status: string): string {
  return status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
}

/**
 * Calculate business days between two dates.
 */
export function calculateBusinessDays(startDate: string, endDate: string): number {
  const start = new Date(startDate)
  const end = new Date(endDate)
  let count = 0
  const current = new Date(start)

  while (current <= end) {
    const day = current.getDay()
    if (day !== 0 && day !== 6) count++
    current.setDate(current.getDate() + 1)
  }

  return count
}
